import {createUseStyles} from 'react-jss';

export default createUseStyles({
  clickAndCollectUnavailable: {
    fontSize: 17,
    margin: 0,
  },
});
